import React from 'react';
import { makeConnect, makeObservableConsumer } from '../infrastructure/components/mobx-extensions';
import { GlobalViewModel } from './global.viewmodel';

const GlobalContext = React.createContext<GlobalViewModel>(null);

// global viewmodel can be consumed as regular context
const GlobalVMConsumer = makeObservableConsumer(GlobalContext);

// or connected to particular component in react-redux way
const connectGlobalVM = makeConnect(GlobalContext);

const EventDetailsContext = React.createContext(null);

export { GlobalContext, GlobalVMConsumer, connectGlobalVM, EventDetailsContext };